import React from 'react';
import { Tooltip, TooltipPosition } from '@tableau/widgets';
import { AngularDirective } from '../../common/react/components/AngularDirective';
import { AngularContext } from '../../ts/factories/AngularContextFactory';
import { Messages } from '../../codegen/Localize';

export interface SiteRolePopoverProps {
  readonly angularContext: AngularContext;
  readonly isContainedInDropdownLabel?: boolean;
  readonly testId?: string;
}

export class SiteRolePopover extends React.PureComponent<SiteRolePopoverProps> {
  constructor(props: SiteRolePopoverProps) {
    super(props);
  }
  public render() {
    const iconStyle = this.props.isContainedInDropdownLabel ? 'tb-dropdown-label-icon-on-right tb-icon-help' : 'tb-header-row-icon-centered tb-icon-help';

    return (
      <Tooltip
        getContent={this.getContent}
        position={TooltipPosition.Right}
        maxWidth={700}
        testId={this.props.testId}>
        <div
          aria-label={Messages.siteRolePopoverTitle()}
          className={iconStyle}
        />
      </Tooltip>
    );
  }
  private getContent = (): JSX.Element => {
    return (
      <div>
        <AngularDirective angularContext={this.props.angularContext} template={'<tb:site-role-permissions-table></tb:site-role-permissions-table>'}/>
      </div>
    );
  }
}
